webpackJsonp([1],{

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Form__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Complete__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Complete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Complete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageNotFound__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_PageNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_PageNotFound__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'form',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Form___default.a
  }, {
    path: '/complete',
    name: 'complete',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Complete___default.a
  }, {
    path: '*',
    name: 'page-not-found',
    component: __WEBPACK_IMPORTED_MODULE_4__components_PageNotFound___default.a
  }]
}));

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(192)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(201),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_es6_promise_auto__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_es6_promise_auto__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var registeredAddressesAsJson = sessionStorage.getItem('registeredAddresses');
    var registeredAddresses = registeredAddressesAsJson !== null ? JSON.parse(registeredAddressesAsJson) : [];

    return {
      originalAddress: registeredAddresses.length > 0 ? registeredAddresses[0].original_address : '',
      expiresOn: __WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(registeredAddresses.length > 0 ? registeredAddresses[0].expires_on : 0),
      registeredAddresses: registeredAddresses
    };
  },
  mounted: function mounted() {
    if (this.registeredAddresses.length === 0) {
      this.$router.replace({ name: 'form' });
    }
  }
});

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      originalAddress: '',
      desiredCount: 1,
      sending: false,
      errors: {
        originalAddress: [],
        desiredCount: []
      }
    };
  },
  methods: {
    doRegister: function doRegister() {
      var _this = this;

      this.sending = true;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://cfosha4094.execute-api.ap-northeast-1.amazonaws.com/prod" + '/addresses', {
        original_address: this.originalAddress,
        desired_count: parseInt(this.desiredCount)
      }).then(function (response) {
        console.log(response);

        if (response.status === 204) {
          alert('既に5個の有効なメールアドレスが存在する為作成できませんでした。');
        } else if (response.status === 201) {
          sessionStorage.setItem('registeredAddresses', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(response.data));
          _this.$router.push({ name: 'complete' });
        }
      }).catch(function (e) {
        console.log(e, e.response);

        if (e.response.status === 422 && e.response.data.errors) {
          var processedErrors = {};
          e.response.data.errors.forEach(function (error) {
            var camelCasedName = error.field.replace(/_([a-z])/g, function (g) {
              return g[1].toUpperCase();
            });

            if (!processedErrors[camelCasedName]) {
              processedErrors[camelCasedName] = [];
            }
            processedErrors[camelCasedName].push(error.code === 'custom' ? error.message : 'Something went wrong');
          });

          _this.errors = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this.errors, processedErrors);
        } else {
          alert('サーバー内でエラーが発生した為、登録ができませんでした。後程再度お試し下さい。');
        }
      }).then(function () {
        _this.sending = false;
      });
    }
  }
});

/***/ }),

/***/ 192:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 195:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 19,
	"./af.js": 19,
	"./ar": 26,
	"./ar-dz": 20,
	"./ar-dz.js": 20,
	"./ar-kw": 21,
	"./ar-kw.js": 21,
	"./ar-ly": 22,
	"./ar-ly.js": 22,
	"./ar-ma": 23,
	"./ar-ma.js": 23,
	"./ar-sa": 24,
	"./ar-sa.js": 24,
	"./ar-tn": 25,
	"./ar-tn.js": 25,
	"./ar.js": 26,
	"./az": 27,
	"./az.js": 27,
	"./be": 28,
	"./be.js": 28,
	"./bg": 29,
	"./bg.js": 29,
	"./bn": 30,
	"./bn.js": 30,
	"./bo": 31,
	"./bo.js": 31,
	"./br": 32,
	"./br.js": 32,
	"./bs": 33,
	"./bs.js": 33,
	"./ca": 34,
	"./ca.js": 34,
	"./cs": 35,
	"./cs.js": 35,
	"./cv": 36,
	"./cv.js": 36,
	"./cy": 37,
	"./cy.js": 37,
	"./da": 38,
	"./da.js": 38,
	"./de": 41,
	"./de-at": 39,
	"./de-at.js": 39,
	"./de-ch": 40,
	"./de-ch.js": 40,
	"./de.js": 41,
	"./dv": 42,
	"./dv.js": 42,
	"./el": 43,
	"./el.js": 43,
	"./en-au": 44,
	"./en-au.js": 44,
	"./en-ca": 45,
	"./en-ca.js": 45,
	"./en-gb": 46,
	"./en-gb.js": 46,
	"./en-ie": 47,
	"./en-ie.js": 47,
	"./en-nz": 48,
	"./en-nz.js": 48,
	"./eo": 49,
	"./eo.js": 49,
	"./es": 51,
	"./es-do": 50,
	"./es-do.js": 50,
	"./es.js": 51,
	"./et": 52,
	"./et.js": 52,
	"./eu": 53,
	"./eu.js": 53,
	"./fa": 54,
	"./fa.js": 54,
	"./fi": 55,
	"./fi.js": 55,
	"./fo": 56,
	"./fo.js": 56,
	"./fr": 59,
	"./fr-ca": 57,
	"./fr-ca.js": 57,
	"./fr-ch": 58,
	"./fr-ch.js": 58,
	"./fr.js": 59,
	"./fy": 60,
	"./fy.js": 60,
	"./gd": 61,
	"./gd.js": 61,
	"./gl": 62,
	"./gl.js": 62,
	"./gom-latn": 63,
	"./gom-latn.js": 63,
	"./he": 64,
	"./he.js": 64,
	"./hi": 65,
	"./hi.js": 65,
	"./hr": 66,
	"./hr.js": 66,
	"./hu": 67,
	"./hu.js": 67,
	"./hy-am": 68,
	"./hy-am.js": 68,
	"./id": 69,
	"./id.js": 69,
	"./is": 70,
	"./is.js": 70,
	"./it": 71,
	"./it.js": 71,
	"./ja": 72,
	"./ja.js": 72,
	"./jv": 73,
	"./jv.js": 73,
	"./ka": 74,
	"./ka.js": 74,
	"./kk": 75,
	"./kk.js": 75,
	"./km": 76,
	"./km.js": 76,
	"./kn": 77,
	"./kn.js": 77,
	"./ko": 78,
	"./ko.js": 78,
	"./ky": 79,
	"./ky.js": 79,
	"./lb": 80,
	"./lb.js": 80,
	"./lo": 81,
	"./lo.js": 81,
	"./lt": 82,
	"./lt.js": 82,
	"./lv": 83,
	"./lv.js": 83,
	"./me": 84,
	"./me.js": 84,
	"./mi": 85,
	"./mi.js": 85,
	"./mk": 86,
	"./mk.js": 86,
	"./ml": 87,
	"./ml.js": 87,
	"./mr": 88,
	"./mr.js": 88,
	"./ms": 90,
	"./ms-my": 89,
	"./ms-my.js": 89,
	"./ms.js": 90,
	"./my": 91,
	"./my.js": 91,
	"./nb": 92,
	"./nb.js": 92,
	"./ne": 93,
	"./ne.js": 93,
	"./nl": 95,
	"./nl-be": 94,
	"./nl-be.js": 94,
	"./nl.js": 95,
	"./nn": 96,
	"./nn.js": 96,
	"./pa-in": 97,
	"./pa-in.js": 97,
	"./pl": 98,
	"./pl.js": 98,
	"./pt": 100,
	"./pt-br": 99,
	"./pt-br.js": 99,
	"./pt.js": 100,
	"./ro": 101,
	"./ro.js": 101,
	"./ru": 102,
	"./ru.js": 102,
	"./sd": 103,
	"./sd.js": 103,
	"./se": 104,
	"./se.js": 104,
	"./si": 105,
	"./si.js": 105,
	"./sk": 106,
	"./sk.js": 106,
	"./sl": 107,
	"./sl.js": 107,
	"./sq": 108,
	"./sq.js": 108,
	"./sr": 110,
	"./sr-cyrl": 109,
	"./sr-cyrl.js": 109,
	"./sr.js": 110,
	"./ss": 111,
	"./ss.js": 111,
	"./sv": 112,
	"./sv.js": 112,
	"./sw": 113,
	"./sw.js": 113,
	"./ta": 114,
	"./ta.js": 114,
	"./te": 115,
	"./te.js": 115,
	"./tet": 116,
	"./tet.js": 116,
	"./th": 117,
	"./th.js": 117,
	"./tl-ph": 118,
	"./tl-ph.js": 118,
	"./tlh": 119,
	"./tlh.js": 119,
	"./tr": 120,
	"./tr.js": 120,
	"./tzl": 121,
	"./tzl.js": 121,
	"./tzm": 123,
	"./tzm-latn": 122,
	"./tzm-latn.js": 122,
	"./tzm.js": 123,
	"./uk": 124,
	"./uk.js": 124,
	"./ur": 125,
	"./ur.js": 125,
	"./uz": 127,
	"./uz-latn": 126,
	"./uz-latn.js": 126,
	"./uz.js": 127,
	"./vi": 128,
	"./vi.js": 128,
	"./x-pseudo": 129,
	"./x-pseudo.js": 129,
	"./yo": 130,
	"./yo.js": 130,
	"./zh-cn": 131,
	"./zh-cn.js": 131,
	"./zh-hk": 132,
	"./zh-hk.js": 132,
	"./zh-tw": 133,
	"./zh-tw.js": 133
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 195;

/***/ }),

/***/ 196:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(203),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ad56b5d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(202),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 199:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  null,
  /* template */
  __webpack_require__(200),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 200:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h2', [_vm._v("ページが見つかりません")]), _vm._v(" "), _c('p', [_c('router-link', {
    attrs: {
      "to": {
        name: 'form'
      }
    }
  }, [_vm._v("トップに戻る")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar text-center"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "https://www.eventcreate.jp"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(196),
      "alt": "イベントクリエイト"
    }
  })])])
}]}

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h2', [_vm._v("掲載されている複数のイベントにお申込をされる方へ")]), _vm._v(" "), _c('p', [_vm._v("\n    こちらから申請を行って頂きますと、イベント管理システム「イベントクリエイト」で作成されたイベントの申込に利用できるメールアドレスを発行致します。\n  ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n    発行されたメールアドレスを使い、参加申込を行ってください。\n  ")]), _vm._v(" "), _c('h3', [_vm._v("利用制限")]), _vm._v(" "), _c('p', [_vm._v("ご利用にあたって下記の利用制限がございます。予めご了承下さい。")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.doRegister()
      }
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.errors.originalAddress.length > 0
    }
  }, [_c('label', [_vm._v("転送先のメールアドレス")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.originalAddress),
      expression: "originalAddress"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "your-name@example.jp",
      "required": ""
    },
    domProps: {
      "value": (_vm.originalAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.originalAddress = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.originalAddress), function(e) {
    return _c('p', {
      staticClass: "form-control-feedback"
    }, [(e === 'Should not be empty.') ? _c('span', [_vm._v("入力してください。")]) : (e === 'Should be an email.' || e === 'This domain has no MX record.') ? _c('span', [_vm._v("正しいメールアドレスではありません。入力に誤りが無いかご確認下さい。")]) : (e === 'This domain is not allowed.') ? _c('span', [_vm._v("転送メールアドレス自信を登録する事はできません。")]) : _c('span', [_vm._v(_vm._s(e))])])
  }), _vm._v(" "), _c('p', {
    staticClass: "form-text text-muted"
  }, [_vm._v("※こちらにはあなたのメールアドレスを入力してください。")])], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-danger': _vm.errors.desiredCount.length > 0
    }
  }, [_c('label', [_vm._v("発行するメールアドレスは何件必要ですか？")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.desiredCount),
      expression: "desiredCount"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.desiredCount = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")])]), _vm._v(" "), _vm._l((_vm.errors.desiredCount), function(e) {
    return _c('p', {
      staticClass: "form-control-feedback"
    }, [_c('span', [_vm._v(_vm._s(e))])])
  })], 2), _vm._v(" "), (_vm.sending) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": ""
    }
  }, [_vm._v("お待ち下さい...")]) : _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("発行する")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n    申請されますと、申請件数分の\n    "), _c('code', [_vm._v("*********@fwd.evecre.com")]), _vm._v("\n    というメールアドレスが発行されます。"), _c('br'), _vm._v("\n    発行されたメールアドレス宛に送られたメールは、「あなたのメールアドレス」宛に自動的に転送されます。\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("発行されたメールアドレスの利用期限は、発行から6ヶ月です。期限を過ぎたメールアドレスに送信されるメールは転送されません")]), _vm._v(" "), _c('li', [_vm._v("宛先数（To、Cc、Bccの合計）が50を超えるメールは転送されません")]), _vm._v(" "), _c('li', [_vm._v("10MBバイト（ヘッダー・本文を含める）を超えるメールは転送されません")]), _vm._v(" "), _c('li', [_vm._v("発行されたメールアドレスは、イベントクリエイトで作成されたイベントへの申し込み用途外には利用されないようご注意ください")])])
}]}

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.registeredAddresses.length > 0) ? _c('div', {}, [_c('h2', [_vm._v("メールアドレスの発行申請を承りました")]), _vm._v(" "), _c('p', [_vm._v("\n    「"), _c('b', [_vm._v(_vm._s(_vm.originalAddress))]), _vm._v("」に転送を行うメールアドレスを " + _vm._s(_vm.registeredAddresses.length) + " 件発行致しました。お申込の際は以下をご利用下さい。"), _c('br'), _vm._v("\n    （※同様の内容を上記メールアドレス宛にも送付致しておりますので、ご確認下さい。）\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "registered-addresses"
  }, _vm._l((_vm.registeredAddresses), function(registered) {
    return _c('li', [_vm._v("\n      " + _vm._s(registered.id) + "@fwd.evecre.com\n    ")])
  })), _vm._v(" "), _c('p', [_vm._v("\n    尚、有効期限は「"), _c('b', [_vm._v(_vm._s(_vm.expiresOn.format("YYYY年MM月DD日 HH時mm分")))]), _vm._v("」までとなっておりますので、ご了承下さい。\n  ")]), _vm._v(" "), _c('h3', [_vm._v("発行件数が希望件数に満たない場合")]), _vm._v(" "), _c('p', [_vm._v("\n    転送メールアドレスは1つの転送先あたり、最大で5件までとさせて頂いております。既に登録があった場合、希望する件数に満たない可能性がございます。\n  ")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 207:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[157]);


// WEBPACK FOOTER //
// static/js/app.ba9e41a3e8d1d11e72f0.js